import React from 'react'
import actions from '../actions'
import Form from '../form'

const handleSubmit = async (values, form) => {
  const {
    name,
    region,
    country,
    timezoneName
  } = values

  const {
    setSubmitting,
    setErrors,
    setStatus,
    resetForm
  } = form

  try {
    await actions.create({
      name,
      region,
      country,
      timezone_name: timezoneName
    })

    resetForm()
    setStatus({ success: true })
  } catch (e) {
    setErrors({ http: e.message })
  }
  setSubmitting(false)
}

const initialValues = {
  name: '',
  region: '',
  country: '',
  timezoneName: ''
}

const Create = () => (
  <Form
    handleSubmit={handleSubmit}
    initialValues={initialValues}
  />
)

export default Create
